/**
 * 与用户相关的操作
 */
import * as ACTION from '../constants/types/userTypes'
import * as $$BASE from './baseAction'
import * as $$COMMON from './commonAction'
import * as $$LOTTERY from './lotteryAction'
import * as $$PUSH from './pushAction'
import { Hex_MD5, getCookie } from '../helpers/unit';
import { packageReq } from '../helpers/request';
import { packageObsoleteReq } from '../deconstructionCenter/obsoleteApi';
import { CLIENT_ID } from '../constants/config'
import JSEncrypt from '../helpers/jsencrypt';

// 登录
export function login(user, validcode = '', rsaKey, callback) {

	// 校验
	if (!user.username || !user.password) {
		return $$BASE.openAlert('请正确填写完整的信息');
	}

	const loginpass = _.cloneDeep(user.password);
	//loginpass RSA加密
	const encrypt = new JSEncrypt();
	encrypt.setPublicKey(rsaKey);

	// 附加参数
	user.loginpass = encrypt.encrypt(user.password);
  	user.password = Hex_MD5(user.validcode + Hex_MD5(user.password));
	user.validcode = validcode;

	// OAUTH2.0 规范固定惨
	user.grant_type = 'password';
	user.client_id = CLIENT_ID[window.CLIENT_MODE];

	var payload = packageReq('LOGIN', null, user, 'POST', true);
	return {
		type: ACTION.LOGIN,
		payload,
		extend: {
			saveUser: user.saveUser,
			username: user.username,
			password: loginpass
		},
		ignoreError: true,
		_done_: [
			{
				action: $$COMMON.toggleVaildCode(false),
				takeParam: false
			}
		],
		_error_: [
			{
				action: handleLoginError,
				takeParam: true
			}
		],
		_success_: [
			{
				action: redirectWhenLogin,
				takeParam: true
			},
			{
				action: getUserInfo,
				takeParam: true
			}
		],
		_callbacks_: callback ? [callback] : null
	}

}


// 登录错误处理
export function handleLoginError(data, payload) {
	const { status, message } = data;
	let result = { type: 'NOTHING_TO_DO' };
	switch (status) {
		// 需要输入验证码
		case 20206: {
			result = $$COMMON.toggleVaildCode(true);
			break;
		}
		// 验证码输入错误
		case 20205: {
			alert('验证码错误，请重新输入');
			result = $$COMMON.toggleVaildCode(true);
			break;
		}
		// 用户名密码错误
		case 20203: {
			result = $$BASE.openAlert(message)
			break;
		}
		default: {
			result = $$BASE.openAlert(message)
		}
	}
	return result;
}

// 登陆后跳转
export function redirectWhenLogin(result) {
	const MOBILE_REX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
	if (MOBILE_REX.test(navigator.userAgent)) {
     $.setCookie('stay_status', 'PC', 3600 * 24);
  }
	// 登录密码登录时
	if (result.redirect_uri == '/') {
		if (result.message == 'success') {
			return $$BASE.changeRouter('#/');
		} else {
			window.location.href = '#/';
			return $$BASE.openAlert(result.message);
		}
	}

	// 真人账号登录
	if (result.redirect_uri == '/livegame') {
		if (result.message == 'success') {
			return $$BASE.changeRouter('#/Casino');
		} else {
			window.location.href = '#/Casino';
			return $$BASE.openAlert(result.message);
		}
	}

	// 电子游戏账号登录
	if (result.redirect_uri == '/electronicgame') {
		if (result.message == 'success') {
			return $$BASE.changeRouter('#/Slot');
		} else {
			window.location.href = '#/Slot';
			return $$BASE.openAlert(result.message);
		}
	}

	// 体育游戏账号登录
	if (result.redirect_uri == '/livegame/sportsindex') {
		if (result.message == 'success') {
			return $$BASE.changeRouter('#/sports');
		} else {
			window.location.href = '#/sports';
			return $$BASE.openAlert(result.message);
		}
	}

	// 资金密码登录时
	if (_.includes(result.redirect_uri, 'access_token')) {
		window.STORE.changePasswordToken = _.split(result.redirect_uri, 'access_token=')[1];
		window.location.href = '#/my/changepasswordwithtoken';
		return $$BASE.openAlert('您使用资金密码登录，请先修改密码');
	}

	return { type: 'LOGIN_NO_REDIRECT_URI_MATCH' };

}

/**
 * 通过旧密码修改提款密码/ 通过TOKEN修改提款密码
 * @author ammo 2018-05-15
 * @param  {[type]} oldPassword [description]
 * @param  {[type]} newPassword [description]
 * @return {[type]}             [description]
 */
export function changePasswordWithToken(newPassword, oldPassword, callback) {

	let access_token = window.STORE.changePasswordToken, payloadData = {}

	if (access_token) {
		payloadData = {
			access_token: access_token,
			password: newPassword,
			password_confirmation: newPassword
		}
	}else{
		payloadData = _.merge({
			password: newPassword,
			password_confirmation: newPassword
		}, oldPassword ? {password_original: oldPassword} : {})
	}

	var payload = packageReq('CHANGE_WITHDRAWAL_PASSWORD', null, payloadData, 'PUT', true);
	return {
		type: ACTION.CHANGE_PASSWORD,
		payload,
		_success_: [
			{
				action: access_token ? $$BASE.openAlert('修改密码成功', callback) : $$BASE.openAlert('设定密码成功', callback),
				takeParam: false
			},
			{
				action: getUserProfile(),
				takeParam: false
			}
		]
	}
}

/**
 * 通过旧密码修改登录/ 资金密码登录修改登录密码
 * @author ammo 2018-05-15
 * @param  {[type]} oldPassword [description]
 * @param  {[type]} newPassword [description]
 * @return {[type]}             [description]
 */
export function changePassword(oldPassword, newPassword, callback) {

	let access_token = window.STORE.changePasswordToken, payloadData = {}

	if (access_token) {
		payloadData = {
			access_token: access_token,
			password: newPassword,
			password_confirmation: newPassword
		}
	}
	else {
		payloadData = {
			password_original: oldPassword,
			password: newPassword,
			password_confirmation: newPassword
		}
	}

	var payload = packageReq('CHANGE_PASSWORD', null, payloadData, 'PUT', true);
	return {
		type: ACTION.CHANGE_PASSWORD,
		payload,
		_success_: [
			{
				action: access_token ? $$BASE.openAlert('修改密码成功,请重新登录!') : $$BASE.openAlert('修改密码成功', callback),
				takeParam: false
			},
			{
				action: access_token ? logout() : null,
				takeParam: false
			}
		]
	}
}

// 获取用户信息
export function getUserInfo() {
	// COOKIE 拿上次登录 USERID
	var sess = getCookie('_sessionHandler');
	var user = getCookie('u');

	// 如果老版登录，新版没有登录
	if (sess && user && !window.AUTH_TOKEN) {
		return getTokenBySession(sess);
	}

	// 接口获取用户信息
	var payload = packageReq('USER_BY_ID', null, null, 'GET');
	return {
		type: ACTION.GET_USERINFO,
		payload,
		_error_: [
			{
				action: logout(),
				takeParam: false
			}
		],
		_success_: [
			{
				action: getSessionByToken(window.AUTH_TOKEN),
				takeParam: false
			},
			{
				action: $$LOTTERY.getDynamicMethodInfoFromCache,
				takeParam: true
			},
			{
				action: $$LOTTERY.getDynamicMethodInfo,
				takeParam: true
			},
			{
				action: $$PUSH.getPushServiceInfo(),
				takeParam: false
			},
			{
				action: getUserMenus(),
				takeParam: false
			},
			{
				action: getUnreadChat(),
				takeParam: false
			},
		],
		_done_: [
			{
				action: $$BASE.showUI(0.3),
				takeParam: false
			}
		]
	}
}

// 仅获取用户配置
export function getUserProfile() {

	var payload = packageReq('USER_BY_ID', null, null, 'GET');
	return {
		type: ACTION.GET_USERINFO,
		payload
	}
}

// 获取用户菜单权限
export function getUserMenus() {
	var payload = packageReq('GET_USER_MENUS', null, null, 'GET');
	return {
		type: ACTION.GET_USER_MENUS,
		payload
	}
}

// 获取未读信息条数
export function getUnreadChat() {
	var payload = packageReq('GET_UNREAD_CHAT_COUNT', null, null, 'GET');
	return {
		type: ACTION.GET_UNREAD_CHAT_COUNT,
		payload
	}
}

// 使用TOKEN换取旧版PC的SESSION
export function getSessionByToken(token) {

	var payload = packageReq('GET_SESSION_BY_TOKEN', [CLIENT_ID[window.CLIENT_MODE]], null, 'GET');

	return {
		type: ACTION.GET_SESSION_BY_TOKEN,
		payload
	}
}

// 使用旧版PC的SESSION换取TOKEN
export function getTokenBySession(sessionId) {

	var payload = packageReq('GET_TOKEN_BY_SESSION', [sessionId], null, 'GET');

	return {
		type: ACTION.GET_TOKEN_BY_SESSION,
		payload,
		_success_: [
			{
				action: getUserInfo,
				takeParam: true
			}
		],
		_done_: [
			{
				action: $$BASE.showUI(0.3),
				takeParam: false
			}
		]
	}
}

// 获取用户最近投注信息
export function getUserBetRecent(loading = false) {

	var payload = packageReq('GET_USER_BET_RECENT', null, null, 'GET', loading);
	return {
		type: ACTION.GET_USER_BET_RECENT,
		payload,
		relations:[
			{type: ACTION.CLEAR_USER_BET_RECENT}
		]
	}

}

// 获取平台余额
export function getPlatformBalance(platfromId, getUserInfo) {

	var payload = packageReq('GET_BALANCE_FROM_PLATFORM', [platfromId], null, 'GET');
	return {
		type: ACTION.GET_BALANCE_FROM_PLATFORM,
		payload,
		extend: platfromId,
		ignoreError: true,
		_error_: [
			{
				action: markPlatformUnavailble,
				takeParam: true
			}
		],
		relations: getUserInfo ? [
			getPlatformProfile(platfromId)
		] : null
	}

}

// 获取彩票余额
export function getLotteryBalance() {

	var payload = packageReq('GET_BALANCE_FOR_LOTTERY', null, null, 'GET');

	return {
		type: ACTION.GET_BALANCE_FOR_LOTTERY,
		payload,
	}

}

// 标记用户在某平台不可用
export function markPlatformUnavailble(result, action) {
	return {
		type: ACTION.MARK_PLATFORM_UNAVAILBLE,
		platform: action.extend,
		message: result.message,
		status: result.status,
		code: result.status
	}
}

// 平台转账
export function transferBalance(to, from, money, url) {
	const payloadData = {
		to: to,
		from: from,
		money: money
	}
	var payload = packageReq('TRANSFER_BALANCE', null, payloadData, 'POST', true);
	return {
		type: ACTION.TRANSFER_BALANCE,
		payload,
		_success_: [
			{
				action: to === 'lottery' ? getLotteryBalance() : getPlatformBalance(to),
				takeParam: false
			},
			{
				action: from === 'lottery' ? getLotteryBalance() : getPlatformBalance(from),
				takeParam: false
			},
			{
				action: $$BASE.openAlert('transfer succeeded'),
				takeParam: false
			},
			{
				action:successEntrerGame,
				takeParam: true,
				url:url
			}
		]

	}
}
//导航处第三方transfer succeeded后跳转
export function successEntrerGame(data,payload){
	if(data.status==10000&&payload._success_[3].url){
		window.location.href = payload._success_[3].url
	}
}
// 创建平台账号
export function createPlatformAccount(platform, username, password = '', nickname = '') {
	var payloadData = {
		username: username,
		password: password,
		nickname: nickname
	}
	var payload = packageReq('CREATE_PLATFORM_ACCOUNT', [platform], payloadData, 'POST');
	return {
		type: ACTION.CREATE_PLATFORM_ACCOUNT,
		payload,
		extend: platform,
		_success_: [
			{
				action: $$BASE.openAlert('创建平台账号成功'),
				takeParam: false
			}
		]
	}
}

// 获取平台用户信息
export function getPlatformProfile(platform) {
	var payload = packageReq('GET_PLATFORM_PROFILE', [platform], null, 'GET');
	return {
		type: ACTION.GET_PLATFORM_PROFILE,
		payload,
		extend: platform,
		ignoreError: true
	}
}

/**
 * 注册用户
 * @author ammo 2018-05-12
 * @param  {[type]} agent    [代理，URL第一个参数]
 * @param  {[type]} userType [注册用户类型，URL第二个参数]
 * @param  {[type]} request  [POST参数]
 * @return {[type]}          [description]
 */
export function register(agent, userType, request) {
	var dirtyPayload = packageObsoleteReq('REGISTER', _.join([agent, userType], '/') + '?1=1', request, 'POST');
	return {
		type: ACTION.REGISTER,
		dirtyPayload
	}
}

/**
 * [registerByAgent 代理注册下级用户]
 * @author ammo 2018-05-12
 * @param  {[type]} request [POST参数]
 * @return {[type]}         [description]
 */
export function registerByAgent(request) {
	var dirtyPayload = packageObsoleteReq('REGISTER_BY_AGENT', null, request, 'POST');
	return {
		type: ACTION.REGISTER_BY_AGENT,
		dirtyPayload,
	}
}

/**
 * [CheckSecurityPass 检查提款密码是否正确]
 * @author ammo 2018-05-15
 * @param  {[type]} nextact      [description]
 * @param  {[type]} securityPass [description]
 */
export function checkSecurityPass(nextcon, nextact, securityPass, callback) {

	var payloadData = {
		flag: 'check',
		nextcon: nextcon,
		nextact: nextact,
		secpass: securityPass
	}

	var dirtyPayload = packageObsoleteReq('CHECK_SECURITY_PASS', null, payloadData, 'POST');

	return {
		type: ACTION.CHECK_SECURITY_PASS,
		dirtyPayload,
		callback
	}

}

/**
 * 验证密保问题
 * @author ammo 2018-05-16
 * @param  {[type]} answer   [description]
 * @param  {[type]} question [问题编号]
 * @param  {[type]} ques_num [问题一:1, 问题二:2]
 * @return {[type]}          [description]
 */
export function checkSecurityQuestion(answer, question, ques_num, callback) {

	var payloadData = {
		ans: answer,
		dna_ques: question,
		ques_num: ques_num,
		flag: "check",
		nextcon: "user",
		nextact: "bindsequestion"
	}

	var dirtyPayload = packageObsoleteReq('CHECK_SECURITY_QUESTION', null, payloadData, 'POST');

	return {
		type: ACTION.CHECK_SECURITY_QUESTION,
		dirtyPayload,
		callback
	}

}

/**
 * 设置/修改密保问题
 * @author ammo 2018-05-16
 * @param  {[type]} questions [{q: questionNo, a: answer}] maxLength: 2
 * @param  {[type]} check 验证提款密码成功 返回的checkcode值
 */
export function setSecurityQuestion({questions, check}) {

    const payloadData = {
        questions: questions,
        check
    }

	var payload = packageReq('SET_SECURITY_QUESTIONS', null, payloadData, 'PUT');

	return {
		type: ACTION.SET_SECURITY_QUESTIONS,
		payload,
		_success_: [
			{
				action: $$BASE.openAlert('设置密保问题成功'),
				takeParam: false
			},
			{
				action: getUserProfile(),
				takeParam: false
			}
		]
	}

}


/**
 * [updateWithdrawalPass 修改提款密码] - ###### 当前接口有BUG，可直接调用接口进行密码修改操作 ######
 * @author ammo 2018-05-17
 * @return {[type]} [description]
 */
export function updateWithdrawalPass(newPassword) {

	var payloadData = {
		flag: 'gener',
		pwd: newPassword,
		newsecpass: Hex_MD5(newPassword)
	}

	var dirtyPayload = packageObsoleteReq('UPDATE_WITHDRAWAL_PASS', null, payloadData, 'POST');

	return {
		type: ACTION.UPDATE_WITHDRAWAL_PASS,
		dirtyPayload
	}

}

// 获取未读信息条数
export function getLiveRecord() {
	var payload = packageReq('GET_LIVE_RECORD', null, null, 'GET');
	return {
		type: ACTION.GET_LIVE_RECORD,
		payload
	}
}

// 注销用户
export function logout() {
	var payload = packageReq('LOGOUT', null, null, 'GET');

	return{
		type: ACTION.LOGOUT,
		payload
	}
}

//获取提款地址等信息
export function getWithdrawalListForUsdt(checkcode, callback) {

	var payload = packageReq('GET_WITHDRAWAL_LIST_USDT', [checkcode], null, 'GET');

	return {
		type: ACTION.GET_WITHDRAWAL_LIST_USDT,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//提款前置验证
export function checkWithdrawalDataForUsdt([checkcode,address_id,money], callback) {
	var payloadData = {
		checkcode: checkcode,
		address_id:address_id,
		money:money
	};
	var payload = packageReq('CHECK_WITHDRAWAL_DATA_USDT', null, payloadData, 'POST');

	return {
		type: ACTION.CHECK_WITHDRAWAL_DATA_USDT,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//判断是否开启usdt取款功能
export function checkUsdtAvailable( callback) {
	var payload = packageReq('CHECK_USDT_AVAILABLE', null, null, 'GET');

	return {
		type: ACTION.CHECK_USDT_AVAILABLE,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//usdt提款
export function withdrawalForUsdt([checkcode,address_id,money,withdraw_token], callback) {
	var payloadData = {
		checkcode: checkcode,
		address_id:address_id,
		money:money,
		withdraw_token:withdraw_token
	};
	var payload = packageReq('WITHDRAWAL_USDT', null, payloadData, 'POST');

	return {
		type: ACTION.WITHDRAWAL_USDT,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//获取币种列表
export function getCoinTypeList(callback) {
	var payload = packageReq('GET_COIN_TYPE_LIST', null, null, 'GET');

	return {
		type: ACTION.GET_COIN_TYPE_LIST,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//获取钱包地址
export function getWalletList(checkcode, callback) {
	var payload = packageReq('GET_WALLET_LIST', [checkcode], null, 'GET');

	return {
		type: ACTION.GET_WALLET_LIST,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//锁定钱包
export function lockWallet([checkcode,address], callback) {
	var payloadData = {
		checkcode: checkcode,
		address:address,
	};
	var payload = packageReq('LOCK_WALLET', null, payloadData, 'POST');

	return {
		type: ACTION.LOCK_WALLET,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//重新绑定钱包前置验证
export function checkReBind([checkcode,address,id], callback) {
	var payloadData = {
		checkcode: checkcode,
		address:address,
		id:id
	};
	var payload = packageReq('CHECK_REBIND', null, payloadData, 'POST');

	return {
		type: ACTION.CHECK_REBIND,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//重新绑定钱包
export function modifyWalletAddress([checkcode,address,id,rebinding_token], callback) {
	var payloadData = {
		checkcode: checkcode,
		address:address,
		id:id,
		rebinding_token:rebinding_token
	};
	var payload = packageReq('MODIFY_WALLET_ADDRESS', null, payloadData, 'POST');

	return {
		type: ACTION.MODIFY_WALLET_ADDRESS,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//绑定新钱包
export function bindNewWallet([checkcode,address,coin_type,checklast_token], callback) {
	var payloadData = {
		checkcode: checkcode,
		address:address,
		coin_type:coin_type,
		checklast_token:checklast_token
	};
	var payload = packageReq('BIND_NEW_WALLET', null, payloadData, 'POST');

	return {
		type: ACTION.BIND_NEW_WALLET,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

//验证最后一次绑定钱包地址
export function checkLastBind(address, callback) {
	var payloadData = {
		address:address,
	};
	var payload = packageReq('CHECK_LAST_BIND', null, payloadData, 'POST');

	return {
		type: ACTION.CHECK_LAST_BIND,
		payload,
		_callbacks_: callback ? [callback] : []
	};
}

// 可用的提款方式
export function getWithdrawType() {
	var payload = packageReq('LEGAL_WITHDRAW_TYPE', null, null, 'GET');

	return {
		type: ACTION.LEGAL_WITHDRAW_TYPE,
		payload
	};
}

// 获取安全钱包转账信息
export function getSaftywalletInfo([transfertype],callback) {
  var payload = packageReq('GET_SAFTYWALLET_INFO', [transfertype], null, 'GET');

  return {
    type: ACTION.GET_SAFTYWALLET_INFO,
    payload,
    _callbacks_: callback ? [callback] : []
  };
}

// 安全钱包转账确认
export function checkSaftywalletTransferpost([transfertype,tousername,money,transfer_token],callback) {

  var payloadData = {
    transfer_token: transfer_token,
    money: money,
    tousername: tousername,
    transfertype: transfertype
  };

  var payload = packageReq('CHECK_SAFTYWALLEY_TRANSFERPOST', null, payloadData, 'POST');

  return {
    type: ACTION.CHECK_SAFTYWALLEY_TRANSFERPOST,
    payload,
    _callbacks_: callback ? [callback] : []
  };
}

// 获取用户是否支持安全钱包提款
export function getSaftywalletSupport() {

  var payload = packageReq('SAFTYWALLET_SUPPORT', null, null, 'GET');

  return {
    type: ACTION.SAFTYWALLET_SUPPORT,
    payload
  };
}

// 获取安全钱包提款信息
export function getSaftywalletWithdrawal([checkcode]) {

  var payload = packageReq('GET_SAFTYWALLEY_WITHDRAWAL', [checkcode], null, 'GET');

  return {
    type: ACTION.GET_SAFTYWALLEY_WITHDRAWAL,
    payload
  };
}

// 安全钱包提款信息确认
export function confirmSaftyWallet(data,callback) {

  var payload = packageReq('CONFIRM_SAFTYWALLET_INFO', null, data, 'POST');

  return {
    type: ACTION.CONFIRM_SAFTYWALLET_INFO,
    payload,
    _callbacks_: callback ? [callback] : []
  };
}

// 提交安全钱包提款
export function submitSaftyWallet(data,callback) {

  var payload = packageReq('SBUMIT_SAFTYWALLET_INFP', null, data, 'POST');

  return {
    type: ACTION.SBUMIT_SAFTYWALLET_INFP,
    payload,
    _callbacks_: callback ? [callback] : []
  };
}
